import { isInRange } from "@project-rouge/rg-core";
import { getModuleSizeZ } from "./index154.js";
import { getSortedModules } from "./index156.js";
function tryInsertionMethod(space, apartmentIndex, moduleIndex, apartmentArray, method) {
  if (apartmentIndex >= apartmentArray.length) {
    return { success: false, outOfBounds: "PosJ" };
  }
  let total = 0;
  const threshold = method === "Area" ? space.area[0] : space.sizeX[0];
  const modules = [];
  let currentModules;
  let sizeX = 0;
  let sizeY = Infinity;
  let sizeZ = 0;
  while (total < threshold) {
    if (apartmentIndex >= apartmentArray.length) {
      return { success: false, outOfBounds: "PosJ" };
    }
    currentModules = getSortedModules(apartmentArray, apartmentIndex);
    modules.push(currentModules[moduleIndex]);
    const x = currentModules[moduleIndex].size[0];
    sizeX += x;
    const y = currentModules[moduleIndex].size[1];
    sizeY = Math.min(sizeY, y);
    const z = getModuleSizeZ(currentModules[moduleIndex], apartmentArray[apartmentIndex]);
    sizeZ = Math.max(sizeZ, z);
    total = method === "Area" ? sizeX * sizeZ : sizeX;
    moduleIndex++;
    if (moduleIndex >= currentModules.length) {
      moduleIndex = 0;
      apartmentIndex++;
    }
  }
  const totalArea = sizeX * sizeZ;
  if (!isInRange(totalArea, space.area[0], space.area[1])) {
    return { success: false, outOfBounds: "Area" };
  }
  const totalX = sizeX;
  if (!isInRange(totalX, space.sizeX[0], space.sizeX[1])) {
    return { success: false, outOfBounds: "SizeX" };
  }
  const minY = sizeY;
  if (minY < space.sizeY[0]) {
    return { success: false, outOfBounds: "SizeY" };
  }
  const maxY = sizeY;
  if (maxY > space.sizeY[1]) {
    return { success: false, outOfBounds: "SizeY" };
  }
  const minZ = sizeZ;
  if (minZ < space.sizeZ[0]) {
    return { success: false, outOfBounds: "SizeZ" };
  }
  const maxZ = sizeZ;
  if (maxZ > space.sizeZ[1]) {
    return { success: false, outOfBounds: "SizeZ" };
  }
  return { success: true, unusedArea: total - space.area[0], newPos: { apartmentIndex, moduleIndex } };
}
export {
  tryInsertionMethod
};
//# sourceMappingURL=index143.js.map
